module.exports = __webpack_public_path__ + "static/media/support-icon-white.328ecc93.svg";